import { render, staticRenderFns } from "./BrandMainComponent.vue?vue&type=template&id=a34bd0ae&"
import script from "./BrandMainComponent.vue?vue&type=script&lang=js&"
export * from "./BrandMainComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports